<template>
  <el-dialog :visible.sync="dialogVisible" :title="dialogData.title" width="65%">
     <cs-form v-if="dialogData.title=='批量发布'" ref="sitForm" :form="searchParams" :rules="rules"
      :formData="searchData"
      :inline="true">
    </cs-form>
    <cs-table
        class="no-shadow-table"
        :tableCols="tableCols"
        :showPagination="false"
        :tableData="tableData">
      <template slot-scope="scope" slot="auditTime">
        {{scope.row.auditTime | timeFormat}}
      </template>
      <template slot="lastPushTime" slot-scope="scope">
         <span v-if="scope.row.lastPushTime">{{scope.row.lastPushTime|timeFormat}}</span>
        <span v-else>--</span>
      </template>
      <template slot="control" slot-scope="scope" v-if="dialogData.title=='发布'">
        <el-button type="primary" v-if="scope.row.sitePushFlag==0" size="mini" :disabled="scope.row.sitePushFlag==0">发布</el-button>
        <el-button type="primary" v-else size="mini" @click="releaseEvent(scope.row)">发布</el-button>
      </template>
    </cs-table>
    <div slot="footer" class="dialog-footer" v-if="dialogData.title=='批量发布'">
      <el-button @click="dialogVisible = false">返 回</el-button>
      <el-button type="primary" @click="confirmEvent">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { fetchPushFlag, fetchProgramsPush, fetchProgramsPushs, fetchSetsPushFlag, fetchSetsProgramsPush } from '@/resource/api/index'
export default {
  naem: 'ReleaseDialog',
  props: {
    dialogData: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      dialogVisible: false,
      siteAppOptions: [],
      searchParams: {
        siteAppId: null
      },
      tableCols: [],
      rules: {
        siteAppId: [
          { required: true, message: '请选择站点', trigger: 'change' }
        ]
      },
      tableData: []
    }
  },
  methods: {
    openDialog () {
      this.searchParams.siteAppId = null
      if (this.dialogData.title == '批量发布') {
        this.fetchSiteApps()
      }
      this.getData()
      this.dialogVisible = true
    },
    tableColsShow () {
      this.tableCols = [
        { prop: 'siteAppName', label: '站点' },
        {
          prop: 'sitePushFlag',
          label: '发布进展',
          formatter: function (row, column) {
            let stateText = ''
            switch (row.sitePushFlag) {
              case 0:
                stateText = '队列中'
                break
              case 1:
                stateText = '推送中'
                break
              case 2:
                stateText = '推送失败'
                break
              case 3:
                stateText = '推送成功'
                break
              case 4:
                stateText = '已下线'
                break
              case -1:
                stateText = '未推送'
                break
              case -5:
                stateText = '回调不推送'
                break
              case -999:
                stateText = '- -'
                break
            }
            return stateText
          }
        },
        { prop: 'lastPushTime', label: '更新时间', type: 'slot' },
        { prop: 'retryTimes', label: '重试次数' },
        { prop: 'control', label: '操作', type: 'slot' }
      ]
    },
    getData () {
      const id = this.dialogData.dataObj.id
      if (this.dialogData.isProgram == '节目' && this.dialogData.title == '批量发布') {
        this.tableData = this.dialogData.dataObj.data
        this.tableCols = [
          { prop: 'category', label: '分类' },
          { prop: 'name', label: '节目名称' },
          { prop: 'programSetName', label: '节目集名称' },
          { prop: 'seriesNo', label: '集号' },
          { prop: 'auditTime', label: '审核通过时间', type: 'slot' }
        ]
      } else if (this.dialogData.isProgram == '节目' && this.dialogData.title == '发布') {
        this.tableColsShow()
        const data = {
          id,
          companyId: this.$store.state.router.companyId
        }
        fetchPushFlag(data).then((res) => {
          if (res.code == '1') {
            this.tableData = res.results
          }
        })
      } else {
        this.tableColsShow()
        const data = {
          id,
          companyId: this.$store.state.router.companyId
        }
        fetchSetsPushFlag(data).then((res) => {
          if (res.code == '1') {
            this.tableData = res.results
          }
        })
      }
    },
    // 发布
    releaseEvent (row) {
      this.$confirm('是否确认发布?', '发布确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const siteAppId = row.siteAppId + ''
        const data = {
          id: this.dialogData.dataObj.id,
          siteAppIds: [siteAppId],
          updateBy: this.$store.state.router.updateBySuffix,
          isPuahAgain: 0,
          auditState: 'RE_AUDIT_PASS',
          isPriority: 1
        }
        if (this.dialogData.isProgram == '节目') {
          fetchProgramsPush(data).then((res) => {
            if (res.code != '1') {
              this.$message({
                type: 'error',
                message: res.msg
              })
              return
            }
            this.$message({
              type: 'success',
              message: '发布成功'
            })
            this.dialogVisible = false
            this.$emit('addSuccess')
          })
        } else {
          fetchSetsProgramsPush(data).then((res) => {
            if (res.code != '1') {
              this.$message({
                type: 'error',
                message: res.msg
              })
              return
            }
            this.dialogVisible = false
            this.$message({
              type: 'success',
              message: '发布成功'
            })
            this.$emit('addSuccess')
          })
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 批量发布提交按钮
    confirmEvent () {
      this.$refs.sitForm.validate((valid) => {
        if (valid) {
          this.$confirm('此操作将发布所有数据, 是否继续?', '发布确认', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const programDtos = []
            var idArr = this.dialogData.dataObj.id.split(',')
            idArr.map(item => {
              programDtos.push({
                id: item,
                siteAppIds: this.searchParams.siteAppId,
                updateBy: this.$store.state.router.updateBySuffix
              })
            })
            fetchProgramsPushs({ programDtos: programDtos, createBy: this.$store.state.router.createBySuffix, updateBy: this.$store.state.router.updateBySuffix }).then((res) => {
              if (res.code != '1') {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
                return
              }
              this.dialogVisible = false
              this.$message({
                type: 'success',
                message: '批量发布成功'
              })
              this.$emit('addSuccess')
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
        }
      })
    },
    // 站点查询
    fetchSiteApps () {
      this.siteAppOptions = []
      const id = this.dialogData.dataObj.id
      const data = {
        id: id,
        companyId: this.$store.state.router.companyId
      }
      fetchPushFlag(data).then((res) => {
        if (res.code == '1') {
          res.results.forEach(item => {
            this.siteAppOptions.push({ value: item.siteAppId, label: item.siteAppName })
          })
        }
      })
    }
  },
  computed: {
    searchData () {
      return [
        {
          prop: 'siteAppId',
          type: 'select',
          label: '站点：',
          multiple: true,
          className: 'select-width',
          options: this.siteAppOptions
        }
      ]
    }
  }
}
</script>
<style lang="less">
  .select-width .el-form-item__content{
    width: 500px;
  }
</style>
